<template>
  <div>
    <portal to="page-top-title">Badwords</portal>
    <portal to="page-top-right">
      <btn :route="{ name: 'badwords-categories-new' }" icon="fa-plus" text>Add New</btn>
    </portal>

    <box-table title="List" url="/badwords/categories" :url-query="{ with_count: ['emails'] }" data-prop="categories" loader>
      <template slot="table-header">
        <tr>
          <th>ID</th>
          <th>Category</th>
          <th>Badwords</th>
          <th class="text-center">Active</th>
          <th class="text-right">Created At</th>
          <th class="text-right"></th>
        </tr>
      </template>
      <template slot="table-body">
        <table-row v-for="category in categories" :key="`badwords-categories-tr-${category.id}`" :value="category">
          <td>{{ category.id }}</td>
          <td>{{ category.name }}</td>
          <td>
            <badge title="Total">{{ category.badwords_count_total }}</badge>
            <badge title="Active" color="green">{{ category.badwords_count_active }}</badge>
            <badge title="Inactive" color="red">{{ category.badwords_count_inactive }}</badge>
          </td>
          <td class="text-center">
            <badge-active :value="category.active"/>
          </td>
          <td class="text-right">{{ category.created_at }}</td>
          <td class="text-right">
            <btn :route="{ name: 'badwords-categories-edit', params: { id: category.id } }" icon="fa-edit">Edit</btn>
            <btn :route="{ name: 'badwords-categories-single', params: { id: category.id } }" color="info" icon="fa-eye">Show</btn>
          </td>
        </table-row>
      </template>
    </box-table>
  </div>
</template>

<script>
import BoxTable from '@/views/components/data/BoxTable'
import Btn from '@/views/components/simple/Btn'
import Badge from '@/views/components/simple/Badge'
import BadgeActive from '@/views/components/simple/BadgeActive'

export default {
  name: 'BadwordCategoriesList',
  metaInfo: {
    title: 'Badword | Categories'
  },
  components: {
    BoxTable,
    Btn,
    Badge,
    BadgeActive
  },
  data () {
    return {
      categories: []
    }
  }
}
</script>
